import { DoqFaceSvgProps } from '../types';

const MissingOrg = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1698_47444)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-missing-org">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#E8D4FF"
        mask="url(#bottom-mask-missing-org)"
      />

      <mask
        id="mask0_1698_47444"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_47444)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <path
        d="M144 206C144 204.895 144.895 204 146 204H174C175.105 204 176 204.895 176 206C176 207.105 175.105 208 174 208H146C144.895 208 144 207.105 144 206Z"
        fill="#2974C4"
      />
      <path
        opacity="0.99"
        d="M240.074 108.408C240.074 108.408 237.354 90.3803 233.079 79.2086C228.804 68.0546 221.806 49.9844 211.307 45.294C194.978 38 160 38 160 38C160 38 127.732 38 108.683 45.294C97.9858 49.3963 91.1928 68.0546 86.9205 79.2086C82.6464 90.3803 79.9228 108.408 79.9228 108.408C79.9228 108.408 67.8714 113.558 56.993 119.578C46.1058 125.587 38.3231 135.885 36 147.054C39.4997 181.4 79.533 196 79.533 196C79.533 196 79.533 167.66 81.4733 157.787C83.419 147.913 87.6895 143.613 104.412 136.32C121.12 129.025 160 126.439 160 126.439C160 126.439 198.873 129.025 215.586 136.32C232.3 143.613 236.579 147.913 238.525 157.787C240.462 167.66 240.462 196 240.462 196C240.462 196 280.498 181.4 284 147.054C281.666 135.885 273.892 125.587 263.007 119.578C252.125 113.558 240.074 108.408 240.074 108.408Z"
        fill="#2B75C5"
      />
      <path
        opacity="0.99"
        d="M85.3393 84C85.3393 84 121.965 72 160 72C198.036 72 234.683 84 234.683 84L237.933 96C237.933 96 198 85.6289 160 85.6289C122 85.6289 82.126 96 82.126 96L85.3393 84Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M240 108.408C240 108.408 223.472 104.29 200 101.799C176.528 99.3084 174.175 98.9314 160 98.9314C145.825 98.9314 143.173 98.9414 120.649 101.424C98.1249 103.907 79.9228 108.408 79.9228 108.408C79.9228 108.408 67.8714 113.558 56.993 119.578C46.1058 125.587 38.3231 135.885 36 147.054C39.4997 181.4 79.533 196 79.533 196C79.533 196 79.533 167.66 81.4733 157.787C83.419 147.913 87.6895 143.613 104.412 136.32C121.12 129.025 160 126.439 160 126.439C160 126.439 198.873 129.025 215.586 136.32C232.3 143.613 236.579 147.913 238.525 157.787C240.462 167.66 240.462 196 240.462 196C240.462 196 280.498 181.4 284 147.054C281.666 135.885 273.892 125.587 263.007 119.578C252.125 113.558 240 108.408 240 108.408Z"
        fill="#0D3E72"
      />
      <circle cx="178" cy="177" r="15" fill="#D9DEE3" fillOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.89 188.804C189.409 193.188 184.033 196 178 196C167.507 196 159 187.493 159 177C159 166.507 167.507 158 178 158C188.493 158 197 166.507 197 177C197 177.51 196.98 178.015 196.941 178.514C196.981 178.677 197.002 178.847 197 179.022L196.5 223.522C196.487 224.627 195.582 225.512 194.478 225.5C193.373 225.487 192.488 224.582 192.5 223.478L192.89 188.804ZM193 177C193 185.284 186.284 192 178 192C169.716 192 163 185.284 163 177C163 168.716 169.716 162 178 162C186.284 162 193 168.716 193 177Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M148 268C148 270.209 146.209 272 144 272C141.791 272 140 270.209 140 268C140 265.791 141.791 264 144 264C146.209 264 148 265.791 148 268Z"
          fill="#2974C4"
        />
        <path
          d="M164 268C164 270.209 162.209 272 160 272C157.791 272 156 270.209 156 268C156 265.791 157.791 264 160 264C162.209 264 164 265.791 164 268Z"
          fill="#2974C4"
        />
        <path
          d="M176 272C178.209 272 180 270.209 180 268C180 265.791 178.209 264 176 264C173.791 264 172 265.791 172 268C172 270.209 173.791 272 176 272Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1698_47444">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { MissingOrg };
